export default __webpack_public_path__ + "assets/images/user.9f7d2e8f015569bbee84f7da27c88530.svg";